<template>
  <el-button class="course-status" :disabled="disabled" :class="statusClass" @click="handleClick">
    <span class="living-icon" v-if="showLiving">
      <span></span>
    </span>
    <span class="btn-text"> {{ text }} </span>
  </el-button>
</template>
<script>
export const BUTTON_TYPE = {
  PRIMARY: 'PRIMARY',
  COMMON: 'COMMON',
  INFO: 'INFO',
};
export function debounce(func, wait, immediate = false) {
  let timeout = null;
  const that = this;

  return function (...args) {
    const context = that;

    if (timeout) {
      clearTimeout(timeout);
    }

    const callNow = immediate && !timeout;

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}
export default {
  name: 'YawwButton',
  props: {
    text: {
      type: String,
      default: '等待开课',
    },
    type: {
      type: String,
      default: BUTTON_TYPE.COMMON,
      validator: (value) => Object.keys(BUTTON_TYPE).includes(value),
    },
    showLiving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    statusClass() {
      return `status-${this.type}`;
    },
  },
  created() {
    this.handleClick = debounce(
      () => {
        this.$emit('click');
      },
      500,
      true,
    );
  },
};
</script>
<style lang="scss" scoped>
.course-status {
  border-radius: 30px;
  font-size: 14px;
  border: none;
  transition: all 0.3s;
  width: 104px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  .btn-text {
    vertical-align: middle;
  }

  &.status-INFO {
    background-color: #eaf0ff;
    color: #3c3a43;
    &.is-disabled {
      border: none !important;
      box-shadow: none;
      background-color: #f1f5ff !important;
      color: #b0b1bc !important;
    }
    &:hover {
      background-color: rgba(191, 207, 248, 0.7);
    }
  }

  &.status-COMMON {
    background-color: #ffebeb;
    color: #ff2020;
    &.is-disabled {
      border: none !important;
      box-shadow: none;
      background-color: #ffebeb !important;
      color: #f89797 !important;
    }
    &:hover {
      background-color: #fcc;
    }
  }

  &.status-PRIMARY {
    background-color: #ff2020;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    &.is-disabled {
      border: none !important;
      box-shadow: none;
      background-color: #f89797 !important;
      color: #fff !important;
    }
    &:hover {
      background-color: #e50000;
    }

    .living-icon {
      position: relative;
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      width: 16px;
      height: 16px;

      &::before,
      &::after,
      span {
        content: '';
        position: absolute;
        width: 2px;
        background-color: #fff;
        border-radius: 1px;
        transform-origin: bottom;
      }

      &::before {
        left: 2px;
        height: 6px;
        animation: bounce 0.6s ease-in-out infinite;
      }

      span {
        left: 7px;
        height: 11px;
        animation: bounce 0.6s ease-in-out infinite;
        animation-delay: 0.2s;
      }

      &::after {
        right: 2px;
        height: 6px;
        animation: bounce 0.6s ease-in-out infinite;
        animation-delay: 0.4s;
      }
    }
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0.6);
  }
}
</style>
